import {Listbox} from '@headlessui/react'
import React, {useMemo, useState} from 'react'
import ic_sort from '../../assets/images/ic_sort.png'
import WizImage from '../image/WizImage'
import Text from '../text/Text'
import {getIDfromList, getListFromKeyword, getValueFromId, IOptions, SelectLabelsKeyword} from './constSelect'
import useQueryExchanges from '../../hooks/etc/useQueryExchanges'
import img_exchange from '../../assets/images/ic_exchange.png'

interface ISelect {
    className?: string
    optionKey?: SelectLabelsKeyword
    customOption?: IOptions[]
    onChange?: (e?: any) => void
    value?: string | number
    buttonClassName?: string
    disabled?: boolean
    optionsClassName?: string
    useImage?: boolean
}

const WizSelect: React.FC<ISelect> = ({
    value,
    className,
    optionKey,
    onChange,
    customOption,
    buttonClassName,
    disabled = false,
    optionsClassName,
    useImage = false,
}) => {
    const initVal = useMemo(
        () => (customOption ? value : getValueFromId(optionKey, value) || getListFromKeyword[optionKey]?.at(0)?.value),
        [value, customOption],
    )
    const {data: exchangeData} = useQueryExchanges()
    const [item, setItem] = useState('')
    const options = useMemo(() => {
        return customOption ? customOption : optionKey ? getListFromKeyword[optionKey] : []
    }, [customOption, optionKey])
    if (!options) {
        return null
    }
    return (
        <Listbox
            disabled={disabled}
            onChange={e => {
                if (customOption) {
                    onChange && onChange(e)
                } else {
                    onChange && onChange(getIDfromList(optionKey, e))
                }
                setItem(e)
            }}>
            {({open}) => (
                <div className={`relative ${className}`}>
                    <Listbox.Button
                        className={`shadow-normal ${
                            disabled
                                ? 'bg-line03 border-line02'
                                : `bg-white ${open ? 'border-primary' : 'border-line02'}`
                        } min-w-[160px] text-left py-[7px] px-[10px] rounded-[5px] border flex justify-between items-center  ${buttonClassName}`}>
                        <div className={`flex items-center gap-[5px]`}>
                            {optionKey === 'exchange' && (
                                <WizImage
                                    className={'w-[16px]'}
                                    src={
                                        exchangeData?.find(i => i?.display_name.toLowerCase() === item.toLowerCase())
                                            ?.icon || img_exchange
                                    }
                                />
                            )}
                            {useImage ? (
                                <WizImage
                                    className={'w-[16px] rounded-full'}
                                    src={options?.find(i => i?.value === (item || initVal))?.image}
                                />
                            ) : null}
                            <Text className={`text-body2 ${disabled && 'text-font04'}`}>{item || initVal}</Text>
                        </div>
                        <WizImage src={ic_sort} className={'w-[16px]'} />
                    </Listbox.Button>
                    <Listbox.Options
                        className={`absolute bg-white z-dropdown min-w-[160px] mt-[5px] shadow-normal border border-line02 rounded-[5px] overflow-hidden ${optionsClassName}`}>
                        {options.map(option => (
                            <Listbox.Option
                                key={option?.id}
                                value={option?.value}
                                className={`${
                                    (optionKey === 'exchange' || useImage) && 'flex items-center gap-[5px]'
                                } py-[10px] px-[10px] cursor-pointer text-body2 hover:bg-bg_green hover:text-ti2 hover:text-font_green`}>
                                {optionKey === 'exchange' && (
                                    <WizImage
                                        className={'w-[16px]'}
                                        src={exchangeData?.find(i => i?.name === option?.id)?.icon || img_exchange}
                                    />
                                )}
                                {useImage ? (
                                    <WizImage
                                        className={'w-[16px] rounded-full'}
                                        src={options?.find(i => i?.value === option?.value)?.image}
                                    />
                                ) : null}
                                <Text>{option?.value}</Text>
                            </Listbox.Option>
                        ))}
                    </Listbox.Options>
                </div>
            )}
        </Listbox>
    )
}

export default WizSelect
